<template>
    <v-row>
        <v-col>
            <v-sheet class="pa-5 sheet center" elevation="3" max-width="900">
                <PageHeader>
                    <template #header>
                        <h4>{{ $t("app.submitting-acceptOffer") }}</h4>
                    </template>
                    <template #subheader>
                        {{ $t("app.sub-submitting-acceptOffer") }}
                    </template>
                </PageHeader>
                <div class="loading-wrapper">
                    <Loader />
                </div>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
    import ResolvePayMonthlyRouteAction from "@/action/actions/ResolvePayMonthlyRouteAction"
    import { onMounted } from "vue"
    const props = defineProps<{ refreshPendingStatus?: boolean }>()

    onMounted(async () => {
        await new ResolvePayMonthlyRouteAction({ refreshPendingStatus: !!props.refreshPendingStatus }).invoke()
    })
</script>

<style lang="css" scoped>
    .loading-wrapper {
        height: 329px;
        margin-top: 130px;
    }
</style>
